<script>
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import Config from '@/config'
import ReportPageV2 from '@/components-v2/presentation-report/ReportPageV2.vue'
import { ROUTE_NAMES } from '@/constant/routes'

export default {
  extends: ReportPageV2,
  data() {
    return {
      canUseReportDataMart: false,
    }
  },
  computed: {
    hideShareButton() {
      return true
    },
    canShareReportAsLink() {
      return false
    },
    // Override flag to avoid anything related to multiple session
    canUseMultipleSessions() {
      return false
    },
    // Shared Token from api, we use this instead of presentation id
    sharedToken() {
      return this.$route.params.id
    },
    // override to ignore multiple session
    customPdfExportUrl() {
      return Config.workerApi.exportPdfForSharedReport
    },
    // Override to make sure the owner version is the same as guest, and also ignore multiple session
    customExcelExportUrl() {
      return Config.workerApi.exportExcelForSharedReport
    },
  },
  mounted() {
    this.setDefaultPlan()
    this.getOwnerFlag()
  },
  methods: {
    ...mapActions('presentationReport', [
      'getPresentationDetailByShareToken', 'getSharedReportAndMetricByPresentationId', 'selectSharedReportPresentationAction',
      'subscribeSharedReportAction', 'getPresentationFlagInfoBySharedToken']),
    ...mapActions(['setPlan']),
    // Because if user not logged in, we need to set a default free plan to force plan benefit works
    setDefaultPlan() {
      if (!isEmpty(this.currentUser)) return
      this.setPlan('free')
    },
    // To make sure the owner version is the same as guest
    async getOwnerFlag() {
      const data = await this.getPresentationFlagInfoBySharedToken(this.sharedToken)
      this.canUseReportDataMart = data?.['release-data-mart-individual-report-v2'] ?? false
    },
    // override this so it called the shared Report version instead
    subscribeReportAction(presentation) {
      this.subscribeSharedReportAction({
        ...presentation,
        sharedToken: this.sharedToken,
      })
    },
    // override this so it called the shared Report version instead
    selectPresentationAction({ presentation }) {
      this.selectSharedReportPresentationAction({
        presentation,
        sharedToken: this.sharedToken,
      })
    },
    // override this so it called the shared Report version instead
    getReportAndMetricByPresentationId(params) {
      this.getSharedReportAndMetricByPresentationId({
        sharedToken: this.sharedToken,
        ...params,
      })
    },
    // Multi session, we are not support in shared report yet, so I just override it
    async getPresentationDetailBySession() {
      const res = await this.getPresentationDetailByShareToken(this.sharedToken)
      res.slides = res.Slides
      this.handleDataPresentationDetail({ body: res })
      return res
    },
    // override this so it redirect to shared report route instead of the origin report page
    handleClickAudience(audience) {
      this.$router.push({
        name: ROUTE_NAMES.SHARED_REPORT,
        params: {
          id: this.$route?.params?.id,
          audienceId: audience.audienceId,
        },
      })
      this.handleChangeUrlParams()
    },
    goToPresentationDetail() {
      const { id: presentationId } = this.presentation
      this.$router.push({
        name: 'PresentationDetail',
        params: { id: presentationId },
      })
    },
  },
}

</script>
